import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  FindApolloIdRequest extends  DBObject {  private static readonly _APOLLOID: number = 0 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _apolloId: string = '' ;
 public constructor ( d3eParams ? : Partial<{apolloId: string}> ) {
 super();

this.setApolloId(d3eParams?.apolloId ?? '');
 }
  public get d3eType (  ) : string {
 return 'FindApolloIdRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get apolloId (  ) : string {
 return this._apolloId ; 
 }
  public setApolloId ( val : string ) : void {
 let isValChanged :boolean=this._apolloId !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(FindApolloIdRequest._APOLLOID,this._apolloId);

this._apolloId=val;

this.fire('apolloId',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case FindApolloIdRequest._APOLLOID : {
 return this._apolloId ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : FindApolloIdRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :FindApolloIdRequest=( dbObj as FindApolloIdRequest );

obj.id=this.id;

obj.setApolloId(this._apolloId);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case FindApolloIdRequest._APOLLOID : {
 this.setApolloId(( value as string ));
 break; }
 }
 }
 }